<template>
	<div class="home-main"> 
		<div class="home" v-show="step === 1">
			<img src="../assets/img/home_btn.png" class="home-btn" alt="" @click="onNext(2)">
		</div>
		<div class="home-body" v-show="step > 1">
			<div class="home-body-iconclose">
				<img src="../assets/img/icon_close_content.png" alt="">
				<img src="../assets/img/icon_close_content.png" alt="">
			</div>
			<div class="fj-select" v-show="step === 2">
				<div class="fj-title">疫情后<br>你最想组的饭局是</div>
				<div class="fj-option">
					<div @click="onFanju(index)" v-for="(item, index) in fj_list" :key="item" :style="'background: '+ ( fj_hover[index] ? '#c18b2b' : '' ) +'; color: '+ ( fj_hover[index] ? '#e5c69e' : '' ) +';'">{{ item }}</div>
				</div>
				<img src="../assets/img/next_btn.png" class="next-btn" alt="" @click="onNext(3)">
			</div>
			<div class="lx-select" v-show="step === 3">
				<div class="lx-title">2020年第一个饭局<br>你最想吃的是</div>
				<div class="lx-option">
					<img src="../assets/img/mlhg_btn.png" @click="onLeixing(0)" alt="" v-show="!lx_hover[0]">
					<img src="../assets/img/mlhg_btn_hover.png" @click="onLeixing(0)" alt="" v-show="lx_hover[0]">
					<img src="../assets/img/wqzc_btn.png" @click="onLeixing(1)" alt="" v-show="!lx_hover[1]">
					<img src="../assets/img/wqzc_btn_hover.png" @click="onLeixing(1)" alt="" v-show="lx_hover[1]">
					<img src="../assets/img/hsdpd_btn.png" @click="onLeixing(2)" alt="" v-show="!lx_hover[2]">
					<img src="../assets/img/hsdpd_btn_hover.png" @click="onLeixing(2)" alt="" v-show="lx_hover[2]">
					<img src="../assets/img/jzxc_btn.png" @click="onLeixing(3)" alt="" v-show="!lx_hover[3]">
					<img src="../assets/img/jzxc_btn_hover.png" @click="onLeixing(3)" alt="" v-show="lx_hover[3]">
				</div>
				<img src="../assets/img/next_btn.png" class="next-btn" alt="" @click="onNext(4)">
			</div>
			<div class="cd-select" v-show="step === 4">
				<div class="cd-select-title">{{ lx_name[lx_number] }}</div>
				<div class="cd-select-body">
					<div class="cd-select-list">
						<div class="cd-select-item" v-for="item in 8" :key="item">
							<img src="../assets/img/icon_select.png" class="cd-selct-icon" alt="" v-show="cd_hover[item]">
							<img :src="'./img/'+ lx_lable[lx_number] +'/' + item + '.png'" class="cd-select-item-img" alt="" @click="onCaidan(item)">
						</div>
					</div>
					<img src="../assets/img/next_btn.png" class="next-btn" alt="" @click="onNext(5)">
				</div>
			</div>
			<div class="cd-select" v-show="step === 5">
				<div class="cd-select-title">饮品单</div>
				<div class="cd-select-body">
					<div class="cd-select-list">
						<div class="cd-select-item" v-for="item in 10" :key="item">
							<img src="../assets/img/icon_select.png" class="cd-selct-icon" alt="" v-show="yl_hover[item]">
							<img :src="'./img/yl/' + item + '.png'" class="cd-select-item-img" alt="" @click="onYinliao(item)">
						</div>
					</div>
					<img src="../assets/img/ok_btn.png" class="next-btn" alt="" @click="onSuccess">
				</div>
			</div>
			<div class="create" v-show="step === 6">
				<div class="create-title">{{ create_title }}</div>
				<div class="create_draw">
					<canvas id="canvas" width="889" height="1148"></canvas>
				</div>
				<div class="create-join-title" v-if="list.length > 0">已加入饭局的人有：</div>
				<div class="create-add">
					<div class="create-add-item" v-for="item in list" :key="item._id">
						<img :src="item.userinfo.headimgurl" alt="">
						<div>{{ item.userinfo.nickname }}</div>
					</div>
				</div>
				<img src="../assets/img/share_btn.png" class="next-btn" alt="" @click="sharePoster" v-show="!is_long && is_create">
				<img src="../assets/img/long_share_btn.png" class="next-btn" alt="" v-show="is_long && (is_create || is_join)">
				<div class="create-btn" v-if="!is_create || is_join">
					<img src="../assets/img/join_btn.png" alt="" v-show="!is_join" @click="onJoin">
					<img src="../assets/img/create_btn.png" alt="" v-show="!is_join" @click="onCreate">
				</div>
			</div>
			<div class="poster" v-show="(step === 6 || is_long) && (is_create || is_join)" :style="'height: ' + ((is_long && (is_create || is_join)) ? 'auth' : 0)">
				<canvas id="poster" width="1080" height="1920"></canvas>
				<img src="" alt="" id="poster-img" :style="'height: ' + ((is_long && (is_create || is_join)) ? 'auto' : 0)">
			</div>
			<div class="home-body-iconclose">
				<img src="../assets/img/icon_close_content.png" alt="">
				<img src="../assets/img/icon_close_content.png" alt="">
			</div>
		</div>
	</div>
</template>

<script>
import QRious from 'qrious'
import CONFIG from '@/utils/config'
import COVERAPP from '@/utils/COVERAPP'
import COVER from '@/utils/COVER'

import { mapState, mapActions } from 'vuex'

const fjName = ['闺蜜趴', '兄弟小聚', '同事欢庆', '家庭聚会', '情侣约会'];  // 饭局名称
let id = '';  // 饭局ID
let fjType = 0;
const fjLable = ['hg', 'zc', 'dpd', 'xc'];
let fjSet = 'hg';
let boardData = '';  // 海报分享餐桌数据
let posterDesc = [
	['樱花依然浪漫，生活灿烂如初！'],
	['跟爱的人一起，', '就是平淡生活中的小幸福！'],
	['见想见的人，做想做的事，', '如此美好！'],
	['往后岁月，愿你安好，我常伴！']
];
let posterBase64 = '';

export default {
	name: 'home',
	data() {
		return {
			step: 1,
			fj_list: fjName,
			fj_type: 0,
			fj_hover: [true],
			lx_name: ['麻辣火锅', '温情中餐', '豪爽大排档', '精致西餐'],
			lx_lable: fjLable,
			lx_number: 0,
			lx_hover: [true],
			cd_hover: [],
			yl_hover: [],
			list: [],
			is_long: false,  // 是否长按保存图片
			is_create: true,
			is_join: false,
			create_title: ''
		}
	},
	computed: {
    ...mapState(['aid', 'activityData', 'shareData', 'userinfo'])
	},
	created() {
		const query = this.$route.query || {};
		id = query.id || '';
		
		if (id) {
			this.detail();
			return;
		}

		document.querySelector('.loading-wrap').style.display = 'none'	
		this.setPageLoadingAsync(false)
	},
	mounted() {
		this.share()
	},
	methods: {
		...mapActions([
			'setPageLoadingAsync',
			'getUserinfoAsync',
			'setshareDataAsync',
			'getActivityDataAsync'
		]),
		share() {
			COVER.share(this.shareData)
		},
		detail() {
			const _this = this;
			const userinfo = this.userinfo;
			COVER.$request('/assist/index', {
				id,
				aid: this.aid,
				uid: userinfo.token
			}, 'POST').then(res => {
				document.querySelector('.loading-wrap').style.display = 'none'
				this.setPageLoadingAsync(false)
				if (res.errno === 0) {
					const data = res.data;
					const detail = data.detail;

					this.fj_type = detail.info.type;
					this.lx_number = detail.info.series;
					this.list = data.list;
					this.step = 6;
					this.is_create = data.is_create;
					this.is_join = data.is_join;
					this.create_title = '2020第一个'+ this.fj_list[detail.info.type] +'饭局邀请函';

					if (data.is_join) {
						let nickname = detail.info.nickname;
						if (nickname.length > 3) {
							nickname = detail.info.nickname.slice(0, 3) + '*';
						}
						this.create_title = '加入了'+ nickname +'的'+ this.fj_list[detail.info.type] +'饭局邀请';
					}
					
					this.$nextTick(() => {
						if (data.is_join) {
							COVER.$request('/qiniu/upimg', {
								url: userinfo.headimgurl,
								token: userinfo.token
							}).then(ret => {
								if (ret.errno === 0) {
									const url = 'https://yunyingcdn.thecover.cn/' + ret.data;
									_this.draw(detail.info.cp, detail.info.yl, url, userinfo.nickname);
								} else {
									_this.draw(detail.info.cp, detail.info.yl, 'http://7xte9b.com2.z0.glb.qiniucdn.com/o_1e24t79g514bf1moqas714ebb9b9.png', userinfo.nickname);
								}
							});
							return;
						}
						_this.draw(detail.info.cp, detail.info.yl, detail.info.avatar, detail.info.nickname);
					});
					return;
				}
				window.location.href = window.location.origin + '/2020fanju/';
			});
		},
		onNext(step) {
			if (step === 2) {
				if (!COVERAPP.Attribute.isApp() && !COVERAPP.Attribute.isWeixin()) {
					const activityData = this.activityData;
					activityData.isApp = 1;
					this.activityData = activityData;
					return;
				}
				document.querySelector('#bg-audio').play();
				const userinfo = this.userinfo;
				if (!userinfo.token) {
					this.getUserinfoAsync();
					return;
				}
			}

			if (step === 5) {
				const cd_hover = this.cd_hover || [];
				let is_cd = 0;
				for (let i = 0; i < cd_hover.length; i++) {
					if (cd_hover[i]) {
						is_cd++;
					}
				}

				if (is_cd < 4) {
					return alert('亲，菜品4份起哦，选自己喜欢的吧！');
				}
			}
			this.step = step;
		},
		onFanju(index) {
			let hover = [];
			hover[index] = true;
			this.fj_type = index;
			this.fj_hover = hover;
		},
		onLeixing(index) {
			let hover = [];
			hover[index] = true;
			this.lx_number = index;
			this.lx_hover = hover;
		},
		onCaidan(index) {
			let hover = JSON.parse(JSON.stringify(this.cd_hover));
			hover[index] = !hover[index];
			this.cd_hover = hover;
		},
		onYinliao(index) {
			let hover = JSON.parse(JSON.stringify(this.yl_hover));
			hover[index] = !hover[index];
			let number = 0;

			for (let i = 0; i < hover.length; i++) {
				if (hover[i]) {
					number++;
				}
			}

			if (number > 3) {
				return alert('最多选择三种饮品');
			}
			this.yl_hover = hover;
		},
		// 完成点餐
		onSuccess() {
			const _this = this;
			const cd_hover = this.cd_hover || [];
			const yl_hover = this.yl_hover || [];
			let cp = [], yl = [];
			for (let i = 0; i < cd_hover.length; i++) {
				if (cd_hover[i]) {
					const index = i;
					cp.push(index);
				}
			}

			for (let i = 0; i < yl_hover.length; i++) {
				if (yl_hover[i]) {
					const index = i;
					yl.push(index);
				}
			}

			if (yl.length <= 0) {
				return alert('请选择饮品');
			}

			const type = this.fj_type;  // 饭局类型
			const series = this.lx_number;  // 菜系

			const userinfo = this.userinfo;
			const avatar = userinfo.headimgurl;
			const nickname = userinfo.nickname;

			document.querySelector('.loading-wrap').style.display = 'flex';

			if (avatar) {
				COVER.$request('/qiniu/upimg', {
					url: avatar,
					token: userinfo.token
				}).then(ret => {
					if (ret.errno === 0) {
						const url = 'https://yunyingcdn.thecover.cn/' + ret.data;
						create(url);
					} else {
						create('http://7xte9b.com2.z0.glb.qiniucdn.com/o_1e24t79g514bf1moqas714ebb9b9.png');
					}
				});
			} else {
				create('http://7xte9b.com2.z0.glb.qiniucdn.com/o_1e24t79g514bf1moqas714ebb9b9.png');
			}
			

			function create(avatar) {
				COVER.$request('/assist/create', {
					aid: _this.aid,
					uid: userinfo.token,
					info: JSON.stringify({
						type,
						series,
						cp,
						yl,
						avatar,
						nickname
					}),
					userinfo: JSON.stringify(userinfo)
				}, 'POST').then(res => {
					document.querySelector('.loading-wrap').style.display = 'none';
					if (res.errno === 2001) {
						return alert('饭局未开始');
					}

					if (res.errno === 2002) {
						return alert('饭局已结束');
					}

					if (res.errno === 2007) {
						return alert('已创建了饭局');
					}

					if (res.errno === 0) {
						id = res.data.id;
						_this.step = 6;
						_this.create_title = '2020第一个'+ _this.fj_list[_this.fj_type] +'饭局邀请函';
						_this.$nextTick(() => {
							_this.draw(cp, yl, avatar, nickname);
						});
					}
				})
			}
		},
		/**
		 * 绘制海报图
		 * cp  菜品
		 * yl  饮料
		 * tx  头像地址
		 * nc  昵称
		 */
		draw(cp, yl, tx, nc) {
			document.querySelector('.loading-wrap').style.display = 'flex';
			const _this = this;
			const lable = this.lx_lable[this.lx_number];
			const $canvas = document.getElementById('canvas');
			const ctx = $canvas.getContext('2d');
			let bg = new Image();
			bg.src = './img/'+ lable +'_bg.png';
			bg.onload = function() {
				ctx.fillStyle = '#ffc729';
				ctx.fillRect(0, 0, bg.width, bg.height);
				ctx.drawImage(bg, 0, 0, bg.width, bg.height, 0, 0, bg.width, bg.height);
				
				// 绘制头像背景
				ctx.save();
				ctx.beginPath();
				ctx.arc(bg.width * 0.5, bg.width * 0.135, bg.width * 0.1, 0, Math.PI * 2, false);
				ctx.closePath();
				ctx.clip();
				ctx.fillStyle = "#bf8b16";
				ctx.fill();
				ctx.restore();

				// 绘制头像
				let avatar = new Image();
				avatar.crossOrigin = 'anonymous';
				avatar.src = tx;
				avatar.onload = function() {
					ctx.save();
					ctx.beginPath();
					ctx.arc(bg.width * 0.5, bg.width * (0.05 + 0.085), bg.width * 0.085, 0, Math.PI * 2, false);
					ctx.closePath();
					ctx.clip();
					ctx.drawImage(avatar, bg.width * (0.5 - 0.085), bg.width * 0.05, bg.width * 0.17, bg.width * 0.17);
					ctx.restore();

					ctx.font = "24px '黑体'";
					const nickname_width = ctx.measureText(nc).width;
					ctx.fillStyle = '#bf8b16';
					ctx.fillRect((bg.width - nickname_width) / 2 - 15, bg.height * 0.17 - 28, nickname_width + 30, 45);
					
					ctx.fillStyle = '#fff';
					ctx.fillText(nc, (bg.width - nickname_width) / 2, bg.height * 0.172);

					yinliao();

					// 渲染饮料
					function yinliao() {
						let index = 0, is_render = false;
						let yl_show = setInterval(function() {
							if (index >= yl.length) {
								clearInterval(yl_show);
								caipin();
								return;
							}
							if (is_render) {
								return true;
							}
							is_render = true;
							let img = new Image();
							img.src = './img/yl_img/' + yl[index] + '.png';
							img.onload = function() {
								const cp_height = bg.height * 0.15;  // 单个饮料图片高度
								const cp_width = (cp_height / img.height) * img.width;  // 单个饮料图片宽度
								let cp_x = 0, cp_y = 0;
								// 火锅
								if (lable === 'hg') {
									cp_x = bg.width * 0.6 + bg.width * (0.1 * index);  // 饮料 X 轴距离
									cp_y = bg.height * 0.55;  // 饮料 Y 轴距离
								}

								// 中餐
								if (lable === 'zc') {
									cp_x = bg.width * 0.34 + bg.width * (0.1 * index);  // 饮料 X 轴距离
									cp_y = bg.height * 0.45;  // 饮料 Y 轴距离
								}

								// 大排档
								if (lable === 'dpd') {
									cp_x = bg.width * 0.2 + bg.width * (0.1 * index);  // 饮料 X 轴距离
									cp_y = bg.height * 0.35;  // 饮料 Y 轴距离
								}

								// 西餐
								if (lable === 'xc') {
									cp_x = bg.width * 0.15 + bg.width * (0.1 * index);  // 饮料 X 轴距离
									cp_y = bg.height * 0.38;  // 饮料 Y 轴距离
								}
								
								ctx.drawImage(img, cp_x, cp_y, cp_width, cp_height);
								index++;
								is_render = false;
							}
						}, 10);
					}

					// 渲染菜品
					function caipin() {
						let index = 0, is_render = false;
						let cp_show = setInterval(function() {
							if (index >= cp.length) {
								clearInterval(cp_show);
								boardData = ctx.getImageData(0, 0, bg.width, bg.height);
								_this.drawPoster();
								return;
							}
							if (is_render) {
								return true;
							}
							is_render = true;
							let img = new Image();
							img.src = './img/'+ lable +'_img/' + cp[index] + '.png';
							img.onload = function() {
								let w = 0.28;

								if (lable === 'dpd') {
									w = 0.20;
								}

								if (lable === 'xc') {
									w = 0.22;
								}
								const cp_width = bg.width * w;  // 单个菜品图片宽度
								const cp_height = (cp_width / img.width) * img.height;  // 单个菜品图片高度
								let cp_x = 0, cp_y = 0;

								if (lable === 'hg') {
									let yRatio = 0.69, ySpace = 0.08;

									if (cp.length < 4) {
										yRatio = 0.79;
									}

									if (cp.length > 3 && cp.length < 7) {
										yRatio = 0.73;
										ySpace = 0.12;
									}
									cp_x = bg.width * 0.06 + (cp_width + bg.width * 0.02) * (index % 3);  // 菜品 X 轴距离
									cp_y = bg.height * yRatio + bg.height * (Math.floor(index / 3) * ySpace);  // 菜品 Y 轴距离
								}

								if (lable === 'zc') {
									let yRatio = 0.59, ySpace = 0.13;

									if (cp.length < 4) {
										yRatio = 0.73;
									}

									if (cp.length > 3 && cp.length < 7) {
										yRatio = 0.65;
										ySpace = 0.17;
									}
									cp_x = bg.width * 0.06 + (cp_width + bg.width * 0.02) * (index % 3);  // 菜品 X 轴距离
									cp_y = bg.height * yRatio + bg.height * (Math.floor(index / 3) * ySpace);  // 菜品 Y 轴距离
								}

								if (lable === 'dpd') {
									let yRatio = 0.52, ySpace = 0.16;

									if (cp.length < 4) {
										yRatio = 0.68;
									}

									if (cp.length > 3 && cp.length < 7) {
										yRatio = 0.62;
										ySpace = 0.2;
									}
									cp_x = bg.width * 0.14 + (cp_width + bg.width * 0.05) * (index % 3);  // 菜品 X 轴距离
									cp_y = bg.height * yRatio + bg.height * (Math.floor(index / 3) * ySpace);  // 菜品 Y 轴距离
								}

								if (lable === 'xc') {
									let yRatio = 0.505, ySpace = 0.17;

									if (cp.length < 4) {
										yRatio = 0.72;
									}

									if (cp.length > 3 && cp.length < 7) {
										yRatio = 0.62;
										ySpace = 0.2;
									}
									cp_x = bg.width * 0.11 + (cp_width + bg.width * 0.05) * (index % 3);  // 菜品 X 轴距离
									cp_y = bg.height * yRatio + bg.height * (Math.floor(index / 3) * ySpace);  // 菜品 Y 轴距离
								}

								ctx.drawImage(img, cp_x, cp_y, cp_width, cp_height);
								index++;
								is_render = false;
							}
						}, 10);
					}

				}
			}
		},
		// 分享海报
		drawPoster() {
			const _this = this;
			const $poster = document.getElementById('poster');
			const ctx = $poster.getContext('2d');

			const bg = new Image();
			bg.src = './img/share_bg.png';
			bg.onload = function() {
				ctx.drawImage(bg, 0, 0, bg.width, bg.height);

				const title = _this.create_title;
				ctx.font = '600 52px "黑体"';
				ctx.fillStyle = '#ffffff';
				const title_width = ctx.measureText(title).width;
				ctx.fillText(title, (bg.width - title_width) / 2, bg.height * 0.145);

				ctx.font = '600 40px "黑体"';
				ctx.fillStyle = '#98690b';

				const desc = posterDesc[Math.floor(Math.random() * 4)];
				
				for (let i = 0; i < desc.length; i++) {
					ctx.fillText(desc[i], bg.width * 0.1, bg.height * 0.85 + i * 55);
				}

				ctx.putImageData(boardData, bg.width * 0.088, bg.height * 0.1755);
				ctx.fillStyle = '#fff';
				ctx.fillRect(bg.width * 0.718, bg.height * 0.815, bg.width * 0.18, bg.width * 0.18);

				const qr = new QRious({
					value: window.location.origin + '/2020fanju/#/?id=' + id
				});
				const qrcode = qr.toDataURL();

				const qrimg = new Image();
				qrimg.src = qrcode;
				qrimg.onload = function() {
					ctx.drawImage(qrimg, bg.width * 0.725, bg.height * 0.82, bg.width * 0.165, bg.width * 0.165);
					document.querySelector('.loading-wrap').style.display = 'none';
					if (!COVERAPP.Attribute.isApp()) {
						_this.is_long = true;
					}

					posterBase64 = $poster.toDataURL();
					document.getElementById('poster-img').setAttribute('src', posterBase64);
					const shareData = _this.shareData || {};
					shareData.link = window.location.origin + '/2020fanju/#/?id=' + id;
					_this.setshareDataAsync(shareData);
					COVER.share(shareData);
				}
			}
		},
		// 分享海报
		sharePoster() {
			const aid = this.aid;
			let shareData = this.shareData;
			COVER.track(aid, 'share', '分享海报到朋友圈');
			if (COVERAPP.Attribute.isApp()) {
				COVERAPP.Method.Share({
          title: shareData.title,  // 分享标题
          desc: shareData.desc,  // 分享描述
          link: shareData.link,
          imgUrl: 'https://wapcdn.thecover.cn/wap/2.3.4/share_logo.png',
          type: 'image',
          imgType: 'png',
          origin: 'Timeline',
          dataUrl: posterBase64.split(';base64,')[1],
          callback: function() {
            COVER.track(aid, 'share', '分享海报成功返回');
          }
        });
			}
		},
		onJoin() {
			if (!COVERAPP.Attribute.isApp() && !COVERAPP.Attribute.isWeixin()) {
				const activityData = this.activityData;
				activityData.isApp = 1;
				this.activityData = activityData;
				return;
			}
			
			const userinfo = this.userinfo;

			if (!userinfo.token) {
				alert('请先登录');
				this.getUserinfoAsync();
				return;
			}

			document.querySelector('.loading-wrap').style.display = 'flex'
			COVER.$request('/assist/join', {
				aid: this.aid,
				id,
				uid: userinfo.token,
				userinfo: JSON.stringify(userinfo)
			}, 'POST').then(res => {
				document.querySelector('.loading-wrap').style.display = 'none'
				if (res.errno === 0) {
					alert('加入成功');
					this.detail();
					return;
				}

				if (res.errno === 2009) {
					alert('您已加入了该饭局');
					return;
				}
			});
		},
		onCreate() {
			window.location.href = window.location.origin + '/2020fanju/';
		}
	}
}
</script>

<style lang="less">
.home-main {
	// display: flex;
	min-height: 100vh;
	background: #ffc729;
	justify-content: flex-end;
	align-items: center;
	padding: 2.5vw 0;
	box-sizing: border-box;
}
.home-body {
	width: 95vw;
	margin: 0 auto;
	min-height: 97.5vh;
	border: 2vw solid #cc8f15;
	box-sizing: border-box;
	border-radius: 5vw;
	display: flex;
	justify-content: space-between;
	flex-direction: column;
	background: url('../assets/img/body_bg.png') no-repeat bottom center;
	background-size: 100%;
	.home-body-iconclose {
		display: flex;
		justify-content: space-between;
		width: 82vw;
		margin: 0 auto;
		padding: 3vw 0;
		img {
			width: 8vw;
			height: 8vw;
		}
	}
}
.home {
	background: url('../assets/img/home_bg.jpg') center top;
	background-size: 100% 100%;
	width: 100vw;
	height: 177.77vw;
	padding-top: 152vw;
	box-sizing: border-box;
	.home-btn {
		width: 48.51vw;
		height: 11.59vw;
		margin: 0 auto;
		display: table;
	}
}
.fj-select {
	box-sizing: border-box;
	opacity: 0;
	transform: rotate(180deg);
	transform-origin: bottom;
	animation: rotate_cy .6s 0s ease forwards;
	margin-top: -5vw;
	.fj-title {
		text-align: center;
		font-size: 6vw;
		color: #7c5412;
		font-weight: bolder;
		margin-bottom: 6vw;
	}
	.fj-option {
		width: 75.8vw;
		margin: 0 auto 34.2vw auto;
		div {
			border: 4px solid #493502;
			color: #825917;
			height: 12.3vw;
			display: flex;
			justify-content: center;
			align-items: center;
			font-size: 5.5vw;
			font-weight: bolder;
			border-radius: 100vw;
			margin-bottom: 6vw;
			box-sizing: border-box;
			background: linear-gradient(to right; #f9d648, #f4bd1d);
		}
	}
}
.next-btn {
	width: 48.51vw;
	height: 11.59vw;
	margin: 0 auto;
	display: table;
}
.lx-select {
	box-sizing: border-box;
	opacity: 0;
	transform: rotate(180deg);
	transform-origin: bottom;
	animation: rotate_cy .6s 0s ease forwards;
	margin-top: -5vw;
	.lx-title {
		text-align: center;
		font-size: 6vw;
		color: #7c5412;
		font-weight: bolder;
		margin-bottom: 6vw;
	}
	.lx-option {
		width: 71.66vw;
		margin: 0 auto 28.2vw auto ;
		display: flex;
		flex-direction: column;
		img {
			width: 100%;
			margin-bottom: 5vw;
		}
	}
}
.cd-select {
	box-sizing: border-box;
	opacity: 0;
	transform: rotate(180deg);
	transform-origin: bottom;
	animation: rotate_cy .6s 0s ease forwards;
	display: flex;
	justify-content: center;
	margin-top: -5vw;
	.cd-select-title {
		background: #c49216;
		color: white;
		font-size: 6vw;
		font-weight: bolder;
		line-height: 1.1em;
		padding: 2vw 7vw;
		display: table;
		position: absolute;
		border-radius: 3vw;
		letter-spacing: 1vw;
	}
	.cd-select-body {
		width: 85vw;
		margin: 5vw auto;
		background: white;
		border-radius: 5vw;
		padding: 9vw 0;
		box-sizing: border-box;
		.cd-select-list {
			width: 62.5vw;
			margin: 0 auto;
			display: flex;
			justify-content: space-between;
			flex-wrap: wrap;
			.cd-select-item {
				width: 28vw;
				margin-bottom: 3.7vw;
				.cd-selct-icon {
					width: 8vw;
					height: 8vw;
					position: absolute;
					margin: -1vw 0 0 -1vw;
				}
				.cd-select-item-img {
					width: 100%;
				}
			}
		}
		.next-btn {
			position: absolute;
			margin: 3vw 0 0 18.25vw;
		}
	}
}
.create {
	.create-title {
		color: white;
		text-align: center;
		font-size: 5vw;
		font-weight: bolder;
		margin-bottom: 5vw;
	}
	.create_draw {
		display: table;
		margin: 0 auto;
		canvas {
			width: 82.3vw !important;
			height: 106.29vw !important;
		}
	}
	.create-btn {
		width: 65vw;
		display: flex;
		justify-content: center;
		margin: 8vw auto 0 auto;
		img {
			width: 30.5vw;
			height: 11.2vw;
			margin: 0 2vw;
		}
	}
	.next-btn {
		margin-top: 8vw;
	}
	.create-join-title {
		font-size: 3.6vw;
		font-weight: bold;
		color: #98690b;
		text-align: center;
		margin-top: 3vw;
	}
	.create-add {
		display: flex;
		justify-content: center;
		flex-wrap: wrap;
		.create-add-item {
			width: 20vw;
			align-items: center;
			position: relative;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			margin-top: 3vw;
			img {
				width: 12vw;
				border-radius: 100vw;
				border: .7vw solid #bf8b16;
				display: table;
				margin: 0 auto;
			}
			div {
				background: #bf8b16;
				font-size: 2.5vw;
				color: white;
				display: block;
				box-sizing: border-box;
				margin: 0 auto;
				padding: .7vw 1.5vw;
				border-radius: .5vw;
				margin-top: -3vw;
				z-index: 9;
				max-width: 100%;
				max-height: 4vw;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
			}
		}
	}
}
.poster {
	width: 100vw;
	position: fixed;
	top: 0;
	left: 0;
	z-index: 99;
	background: #ffc729;
	opacity: 0;
	overflow: hidden;
	#poster {
		width: 100%;
		display: table;
	}
	#poster-img {
		position: fixed;
		top: 0;
		left: 0;
		width: 100vw;
		height: 100vh;
		z-index: 99;
	}
}
@keyframes rotate_cy {
	0% {
		transform: rotate(180deg);
	}
	100% {
		opacity: 1;
		transform: rotate(0deg);
	}
}
</style>